export const DomUtil = {
  query<T extends HTMLElement = HTMLElement>(
    element: HTMLElement,
    selector: string,
    // tslint:disable-next-line: typedef
    throwError = true
  ): T {
    const result = element.querySelector(selector) as T;
    if (!result && throwError) {
      throw new Error("Unable to locate required element: " + selector);
    }

    return result;
  },

  queryAll<T extends HTMLElement = HTMLElement>(
    element: HTMLElement,
    selector: string
  ): T[] {
    return Array.from(element.querySelectorAll(selector));
  }
};
